import { render } from "./ProductsServicesView.vue?vue&type=template&id=11299dfd&scoped=true"
import script from "./ProductsServicesView.vue?vue&type=script&lang=js"
export * from "./ProductsServicesView.vue?vue&type=script&lang=js"

import "./ProductsServicesView.vue?vue&type=style&index=0&id=11299dfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11299dfd"]])

export default __exports__